import React, { useRef,useState } from 'react';
import './App.css';

import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';


import {useAuthState} from 'react-firebase-hooks/auth';
import {useCollectionData} from 'react-firebase-hooks/firestore';

firebase.initializeApp({
  apiKey: "AIzaSyBZZSB5HkMMSSGZy2WLgeGqTZT_8DiwaHA",
  authDomain: "chatter-5e980.firebaseapp.com",
  projectId: "chatter-5e980",
  storageBucket: "chatter-5e980.appspot.com",
  messagingSenderId: "1019351667052",
  appId: "1:1019351667052:web:f2d75fb6ce6937a35aa349"
})

const auth =firebase.auth();
const firestore =firebase.firestore();

function App() {
  const [user]= useAuthState(auth);
  return (
    <div className="App">
      <header>
        <h1>🎻🎥</h1>
        <SignOut/>
      </header>
      <section>
        {user ? <ChatRoom/> : <SignIn/>}
      </section>
    </div>
  );
}

function SignIn(){
  const signInWithGoogle = () =>{
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }
  
  return(
    <button onClick={signInWithGoogle}>Sign in</button>
  )
}

function SignOut(){
  return auth.currentUser && (
    <button onClick={() => auth.signOut()} >Sign Out</button>
  )
}

function ChatRoom(){
  const dummy= useRef();
  const messagesRef =firestore.collection('messages');
  const query = messagesRef.orderBy('createdAt').limit(100);

  const [messages] = useCollectionData(query,{idField: 'id'})
  const [formValue,setFormValue]= useState('');

  const sendMessage = async(e) => {
    e.preventDefault();
    const {uid,photoURL} = auth.currentUser;

    await messagesRef.add({
      text:formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      photoURL
    })

    setFormValue('');
    dummy.current.scrollIntoView({behavior: 'smooth'});
  }

  return (
    <>
    <main>

      {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg}/>)}

      <span ref={dummy}></span>
    </main>
    <form onSubmit={sendMessage}>
      <input value={formValue} onChange={(e) => setFormValue(e.target.value)}/>
      <button type="submit">🐦</button>

    </form>
    </>
  )
}

function ChatMessage(props){
  const {text,uid,photoURL}=props.message;

  const messageClass =uid === auth.currentUser.uid ? 'sent' : 'recieved';
  return (
  <div className={`message ${messageClass}`}>
    <img src={photoURL}/>
  <p>{text}</p>
  </div>
  )
}

export default App;
